/*jshint esversion: 9 */
import React from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
// import { withStyles } from "@material-ui/core/styles";
import {
  doLog,
  getMMDDYYYYTime,
  hasValue,
  notNull,
  updateObject,
} from "../../shared/utility";

import Button from "@material-ui/core/Button";
import classes from "../CrimeSubmission.css";
import * as actions from "../../store/actions/index";
import Grid from "@material-ui/core/Grid";
import Form from "../../components/UI/Form/Form";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

const mappedSelectPropFields = ["COUNTY", "CITY_TOWNSHIP"];

const mappedTextPropFields = [
  "ID",
  "INCIDENTNUMBER",
  "ORI",
  "ASSIGNEDUSERCODE",
  "ASSIGNEDUSERNAME",
  "REVIEWERUSERCODE",
  "REVIEWERUSERNAME",
  "STATUS",
  "STATUSREASON",
  "RMSINCIDENTNUMBER",
  "REQUESTNOTES",
  "PERMISSIONLIST",
];
// If fields are added to this list, also update getMappedPropValue and putMappedPropValue functions

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
// });

const gridSpacing = 0; //0 or 8 or 16 or 24 or 32 or 40
// const quote = '"';
// const singleQuote = "'";

class ReviewDetails extends Form {
  state = {
    searching: false,
    editMode: true,
    timeoutSecs: 10,
    requiredFieldErrMsg: "Required fields are needed",
    keyFieldValue: null,
    //
    reportRunning: false,
    currentFile: null,
    //
    mappedSelectPropFields: mappedSelectPropFields,
    mappedTextPropFields: mappedTextPropFields,
    //
    INCIDENTNUMBER: {
      inputType: "text",
      value: "",
      default: "",
      label: "Incident #",
      maxSize: 20,
      validation: { required: true },
      upperOnly: true,
      keyField: true,
    },
    ID: {
      inputType: "text",
      value: "",
      default: "",
      label: "Incident ID",
      maxSize: 20,
      validation: { required: true },
      upperOnly: true,
      keyField: true,
    },
    ORI: {
      inputType: "text",
      value: "",
      default: "",
      label: "ORI",
      maxSize: 9,
      validation: { required: true },
      upperOnly: true,
    },
    ASSIGNEDUSERCODE: {
      inputType: "text",
      value: "",
      default: "",
      label: "Assigned User Code",
      maxSize: 100,
      validation: { required: true },
    },
    ASSIGNEDUSERNAME: {
      inputType: "text",
      value: "",
      default: "",
      label: "Assigned User Name",
      maxSize: 100,
    },
    REVIEWERUSERCODE: {
      inputType: "text",
      value: "",
      default: "",
      label: "Reviewer User Code",
      maxSize: 100,
      validation: { required: true },
    },
    REVIEWERUSERNAME: {
      inputType: "text",
      value: "",
      default: "",
      label: "Reviewer User Name",
      maxSize: 100,
    },
    STATUS: {
      inputType: "text",
      value: "",
      default: "",
      label: "Status Code",
      maxSize: 10,
    },
    STATUSREASON: {
      inputType: "text",
      value: "",
      default: "",
      label: "Enter an optional comment:",
      maxSize: 100,
    },
    COUNTY: {
      inputType: "select",
      value: null,
      label: "County",
      listName: "countyList",
      codegroup: "61",
      validation: { required: false },
      onChange: (countySelected) => {
        this.handleCountyChange(countySelected);
      },
    },
    CITY_TOWNSHIP: {
      inputType: "select",
      value: null,
      label: "City/Twp",
      listName: "citytwpList",
      codegroup: "62",
      validation: { required: false },
    },
    RMSINCIDENTNUMBER: {
      inputType: "text",
      value: "",
      default: "",
      label: "RMS Incident # (Optional)",
      maxSize: 12,
      validation: { required: false },
      upperOnly: true,
    },
    REQUESTNOTES: {
      inputType: "text",
      value: "",
      label: "Enter request notes to be sent to the submitter (Optional)",
      multiline: true,
      rows: 8,
      validation: { required: false },
    },
    PERMISSIONLIST: {
      inputType: "text",
      value: "",
      default: "",
      label: "Permission List (Optional) (comma separated)",
      maxSize: 50,
      validation: { required: false },
      upperOnly: false,
    },
  };

  componentDidMount() {
    if (doLog())
      console.log("[ReviewDetails] componentDidMount state:", this.state);
    if (doLog())
      console.log("[ReviewDetails] componentDidMount props:", this.props);
    this.copyFieldValuesToState();
  }

  componentDidUpdate() {
    if (doLog())
      console.log("[ReviewDetails] componentDidUpdate state:", this.state);
    if (doLog())
      console.log("[ReviewDetails] componentDidUpdate props:", this.props);
    if (
      this.state.searching &&
      this.props.error === null &&
      hasValue(this.props.result)
    ) {
      if (doLog())
        console.log(
          "[ReviewDetails] componentDidUpdate result:",
          this.props.result
        );
      if (doLog())
        console.log(
          "[ReviewDetails] componentDidUpdate transDesc:",
          this.props.transDesc
        );
      this.setState({ searching: false });
      const resultMsg = this.props.result[0];
      if (
        this.props.transDesc === "incidentUpdate" &&
        resultMsg === "Complete"
      ) {
        this.props.onClearTransDesc();
        this.props.onClearTransactionResult();
      }
    }
    this.getListFiles();
  }

  copyFieldValuesToState() {
    if (doLog())
      console.log(
        "[ReviewDetails]copyFieldValuesToState item:",
        this.props.item
      );
    if (this.props.item !== null) {
      const item = this.props.item;
      for (let field in this.state.mappedTextPropFields) {
        const fieldName = this.state.mappedTextPropFields[field];
        // if (doLog()) console.log(
        //   "[ReviewDetails]copyFieldValuesToState text field:",
        //   fieldName
        // );
        const newValue = notNull(item[fieldName]);
        // if (doLog()) console.log(
        //   "[ReviewDetails]copyFieldValuesToState text newValue:",
        //   newValue
        // );
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: newValue,
          }),
        });
        if (this.state[fieldName].keyField === true) {
          this.setState({ keyFieldValue: item[fieldName] });
        }
      }

      for (let field in this.state.mappedSelectPropFields) {
        const fieldName = this.state.mappedSelectPropFields[field];
        let value = notNull(item[fieldName]);
        // if (doLog()) console.log(
        //   "[ReviewDetails]copyFieldValuesToState select field:",
        //   fieldName
        // );
        if (fieldName === "COUNTY" && value === "")
          value = this.props.agencyCounty;
        if (fieldName === "CITY_TOWNSHIP" && value === "")
          value = this.props.agencyCityTwp;
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: value,
          }),
        });
      }
    }
  }

  getListFiles = () => {
    // console.log("[ReviewDetails] getListFiles ORI:", this.state.ORI.value);
    if (hasValue(this.state.ORI.value)) {
      let done = false;
      const count = this.state.mappedSelectPropFields.length;
      for (let i = 0; i < count && !done; i++) {
        const fieldName = this.state.mappedSelectPropFields[i];
        const listName = this.state[fieldName].listName;
        const codegroup = this.state[fieldName].codegroup;
        // console.log("[ReviewDetails] getListFiles fieldName:", fieldName);
        // console.log("[ReviewDetails] getListFiles listName:", listName);
        // console.log("[ReviewDetails] getListFiles codegroup:", codegroup);
        // console.log("[ReviewDetails] getListFiles list:", this.props[listName]);
        if (hasValue(codegroup)) {
          if (!hasValue(this.props[listName])) {
            if (
              !hasValue(this.state[fieldName].inprocess) ||
              this.state[fieldName].inprocess !== true
            ) {
              this.setState({
                [fieldName]: updateObject(this.state[fieldName], {
                  inprocess: true,
                }),
              });
              let ori = this.state.ORI.value;
              if (listName === "countyList" || listName === "citytwpList")
                ori = "";
              this.props.onFetchValidCodeLists(
                ori,
                this.props.token,
                listName,
                codegroup,
                false,
                false
              );
              done = true;
            }
          } else if (
            hasValue(this.state[fieldName].inprocess) &&
            this.state[fieldName].inprocess === true
          ) {
            console.log(
              "[ReviewDetails] getListFiles inprocess for:",
              fieldName
            );
            let citytwpOptions = null;
            if (fieldName === "CITY_TOWNSHIP") {
              citytwpOptions = [];
              const countyValue = this.props.agencyCounty;
              for (let i = 0; i < this.props.citytwpList.length; i++) {
                const fields = this.props.citytwpList[i];
                const citytwpValue = fields.value;
                if (
                  citytwpValue.startsWith(countyValue) &&
                  hasValue(fields.label)
                ) {
                  // console.log("[ReviewDetails] getListFiles fields:", fields);
                  citytwpOptions.push({
                    value: fields.value,
                    label: fields.label,
                  });
                }
              }
            }

            this.setState({
              [fieldName]: updateObject(this.state[fieldName], {
                inprocess: false,
                optionList: citytwpOptions,
              }),
            });
          } else if (
            fieldName === "CITY_TOWNSHIP" &&
            hasValue(this.state.CITY_TOWNSHIP) &&
            !hasValue(this.state.CITY_TOWNSHIP.optionList)
          ) {
            const citytwpOptions = [];
            const countyValue = this.props.agencyCounty;
            for (let i = 0; i < this.props.citytwpList.length; i++) {
              const fields = this.props.citytwpList[i];
              const citytwpValue = fields.value;
              if (
                citytwpValue.startsWith(countyValue) &&
                hasValue(fields.label)
              ) {
                // console.log("[ReviewDetails] getListFiles fields:", fields);
                citytwpOptions.push({
                  value: fields.value,
                  label: fields.label,
                });
              }
            }
            this.setState({
              [fieldName]: updateObject(this.state[fieldName], {
                optionList: citytwpOptions,
              }),
            });
          }
        }
      }
    }
  };

  handleCountyChange = (countySelected) => {
    if (doLog())
      console.log(
        "[ReviewDetails] handleCountyChange countySelected:",
        countySelected
      );
    const target = countySelected.target;
    if (target.value === -1) {
      this.setState({
        COUNTY: updateObject(this.state.COUNTY, {
          value: "",
          labelValue: null,
        }),
        CITY_TOWNSHIP: updateObject(this.state.CITY_TOWNSHIP, {
          value: "",
          labelValue: null,
        }),
      });
    } else {
      const obj = this.props.countyList.find(
        (option) => option.value === target.value
      );
      const citytwpOptions = [];
      for (let i = 0; i < this.props.citytwpList.length; i++) {
        const fields = this.props.citytwpList[i];
        const citytwpValue = fields.value;
        if (citytwpValue.startsWith(target.value) && hasValue(fields.label)) {
          // console.log("[ReviewDetails] handleCountyChange fields:", fields);
          citytwpOptions.push({ value: fields.value, label: fields.label });
        }
      }
      // console.log("[ReviewDetails] handleCountyChange citytwpOptions", citytwpOptions);
      console.log("[ReviewDetails] handleCountyChange obj", obj);
      this.setState({
        COUNTY: updateObject(this.state.COUNTY, {
          value: target.value,
          labelValue: obj.label,
        }),
        CITY_TOWNSHIP: updateObject(this.state.CITY_TOWNSHIP, {
          value: citytwpOptions[0].value,
          labelValue: citytwpOptions[0].name,
          optionList: citytwpOptions,
        }),
      });
    }
  };

  handleStatusButtonsChange = (event) => {
    const statusSelected = event.target.value;

    if (statusSelected.value === -1)
      this.setState({
        STATUS: updateObject(this.state.STATUS, {
          value: "",
        }),
      });
    else {
      this.setState({
        STATUS: updateObject(this.state.STATUS, {
          value: statusSelected,
        }),
      });
    }

    console.log(
      `[ReviewDetails] handleStatusButtonsChange statusSelected:`,
      statusSelected
    );
  };

  handleCancelButton = () => {
    if (doLog()) console.log("[ReviewDetails] handleCancelButton");
    this.props.onCancel();
  };

  handleSubmitButton = () => {
    if (doLog()) console.log("[ReviewDetails] handleSubmitButton");
    this.issueSubmit();
    this.props.onCancel();
  };

  issueSubmit = () => {
    const transactionType = "CitizenIncidentUpdate";
    const data = {
      agencyCode: this.props.agencyCode,
      incidentNumber: this.state.INCIDENTNUMBER.value,
      id: this.state.ID.value,
      ori: this.state.ORI.value,
      assignedUserCode: this.state.ASSIGNEDUSERCODE.value,
      assignedUserName: this.state.ASSIGNEDUSERNAME.value,
      reviewerUserCode: this.props.userId,
      reviewerUserName: this.props.userName,
      status: this.state.STATUS.value,
      statusReason: this.state.STATUSREASON.value,
      county: this.state.COUNTY.value,
      citytwp: this.state.CITY_TOWNSHIP.value,
      rmsIncidentNumber: this.state.RMSINCIDENTNUMBER.value,
      requestNotes: this.state.REQUESTNOTES.value,
      permissionList: this.state.PERMISSIONLIST.value,
    };
    const request = {
      transactionType,
      data,
    };

    if (doLog()) console.log("[ReviewDetails]issueSubmit request:", request);
    this.setState({ searching: true });
    this.props.onRunTransaction(request, this.props.token, "incidentUpdate");
  };

  render() {
    if (doLog()) console.log("[ReviewDetails]render item:", this.props.item);
    const informationSection = (
      <p className={classes.Information}>
        Reviewing&nbsp;Incident #: {this.props.item.INCIDENTNUMBER}&nbsp;&nbsp;
        Incident Type:{" "}
        {this.props.item.ViaDataItems.CITIZENINCIDENTTYPE.DESCRIPTION}
        &nbsp;&nbsp; Received:{" "}
        {getMMDDYYYYTime(this.props.item.INCIDENTDATETIME)}
      </p>
    );

    let countySection = null;
    if (doLog()) console.log("[ReviewDetails]render ORI:", this.props.item.ORI);
    if (doLog())
      console.log("[ReviewDetails]render countyList:", this.props.countyList);
    if (doLog())
      console.log(
        "[ReviewDetails]render optionList:",
        this.state.CITY_TOWNSHIP.optionList
      );
    if (
      this.props.item.ORI.startsWith("MI") &&
      hasValue(
        this.props.countyList && hasValue(this.state.CITY_TOWNSHIP.optionList)
      )
    ) {
      countySection = (
        <Fragment>
          <Grid item xs={12}>
            <hr />
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("COUNTY", false, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("CITY_TOWNSHIP", false, true)}
          </Grid>
          <Grid item xs={4} />
        </Fragment>
      );
    }

    let pdfSection = <p>PDF goes here</p>;
    const pdfFilePath =
      "/ecop/BirtOutput/CitizenWeb/1/" +
      this.props.agencyCode.toLowerCase() +
      "_" +
      this.props.item.ID +
      "_citizen_incident_report.pdf";
    if (doLog()) console.log("[render] pdfFilePath:", pdfFilePath);
    const appPath = "";
    let filePath = "";
    const baseURL = this.props.baseURL;
    const pathname = "";
    if (doLog()) console.log("[render] pathname:", pathname);
    if (pathname.startsWith(appPath)) {
      filePath = baseURL + pathname + pdfFilePath;
    } else {
      filePath = baseURL + appPath + pathname + pdfFilePath;
    }
    if (doLog()) console.log("[render] filePath:", filePath);
    pdfSection = (
      <iframe
        src={filePath}
        title="Incident Report"
        width="100%"
        height="1120px"
      ></iframe>
    );

    const statusButtonsSelect = (
      <RadioGroup
        value={this.state.STATUS.value}
        onChange={this.handleStatusButtonsChange}
        row={true}
      >
        <FormControlLabel
          label="Received"
          value=""
          control={<Radio color="primary" />}
        />
        <FormControlLabel
          label="Send to RMS"
          value="acceptI"
          control={<Radio color="primary" />}
        />
        <FormControlLabel
          label="Do NOT Send to RMS"
          value="reject"
          control={<Radio color="primary" />}
        />
        <FormControlLabel
          label="Request More Information from Sender"
          value="reqinfo"
          control={<Radio color="primary" />}
        />
      </RadioGroup>
    );

    let requestInfoSection = null;
    if (
      this.state.STATUS.value === "reqinfo" ||
      this.state.STATUS.value === "reqmade" ||
      this.state.STATUS.value === "response"
    ) {
      requestInfoSection = (
        <Fragment>
          <Grid item xs={12}>
            {this.getFormField("REQUESTNOTES", false, true)}
          </Grid>
          <Grid item xs={6}>
            {this.getFormField("PERMISSIONLIST", false, true)}
          </Grid>
          <Grid item xs={6} />
        </Fragment>
      );
    }

    let sendToRMSSection = null;
    if (this.state.STATUS.value === "acceptI") {
      sendToRMSSection = (
        <Fragment>
          <Grid item xs={3}>
            {this.getFormField("RMSINCIDENTNUMBER", false, true)}
          </Grid>
          <Grid item xs={9} />
        </Fragment>
      );
    }

    let reviewSection = (
      <Grid container item spacing={gridSpacing}>
        <Grid item xs={12}>
          <p className={classes.SeparateLabel}>
            Please review the report below to decide if it should be imported or
            not:
          </p>
        </Grid>
        <Grid item xs={12}>
          {pdfSection}
        </Grid>
        <Grid item xs={5}>
          <p className={classes.SeparateLabel}>
            Choose an action to be taken for the incident:
          </p>
        </Grid>
        <Grid item xs={7} />
        <Grid item xs={12}>
          {statusButtonsSelect}
        </Grid>
        {requestInfoSection}
        {sendToRMSSection}
        <Grid item xs={12}>
          {this.getFormField("STATUSREASON", false, true)}
        </Grid>
      </Grid>
    );

    return (
      <Grid container item className={classes.Card} spacing={gridSpacing}>
        {informationSection}
        <Grid item xs={12}>
          <hr />
        </Grid>
        {reviewSection}
        {countySection}
        <Grid item xs={12}>
          <Button
            variant="contained"
            //color="default"
            color="primary"
            size="small"
            onClick={this.handleSubmitButton.bind(this)}
          >
            Submit
          </Button>
          &nbsp;&nbsp;
          <Button
            variant="contained"
            //color="default"
            color="primary"
            size="small"
            onClick={this.handleCancelButton.bind(this)}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log("[ReviewDetails] mapStateToProps state:", state);
  return {
    loading: state.trans.loading,
    error: state.trans.error,
    //
    userId: state.auth.userId,
    userName: state.auth.userName,
    //
    baseURL: state.trans.baseURL,
    pathname: state.trans.pathname,
    //
    result: state.trans.result,
    transDesc: state.trans.transDesc,
    //
    countyList: state.trans.countyList,
    citytwpList: state.trans.citytwpList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRunTransaction: (options, token, transDesc) =>
      dispatch(actions.runTransaction(options, token, transDesc)),
    onClearTransactionResult: () => dispatch(actions.clearTransactionResult()),
    onClearTransDesc: () => dispatch(actions.clearTransDesc()),
    onFetchValidCodeLists: (
      ori,
      token,
      listName,
      codeGroup,
      allFields,
      includeInactive
    ) =>
      dispatch(
        actions.fetchValidCodeLists(
          ori,
          token,
          listName,
          codeGroup,
          allFields,
          includeInactive
        )
      ),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(ReviewDetails)
// );
export default connect(mapStateToProps, mapDispatchToProps)(ReviewDetails);
